<div class="d-flex w-100 px-3 pb-3" *ngIf="view_title">
  <b>{{ "admin.feeders-panel.feeder-config" | translate }}</b>
</div>

<div class="p-3 d-flex flex-column gap-3" style="gap: 15px">
  <!--   <div class="d-flex justify-content-between">
    <h5 class="m-0">Activar Nas 2024</h5>
    <div class="d-flex justify-content-around align-items-center">
      <app-loading-status [status]="loading_lf"></app-loading-status>

      <label class="switch m-0 ml-2">
        <input
          type="checkbox"
          id="lf_block"
          [(ngModel)]="configuration.status_lf_block"
          [value]="configuration.status_lf_block"
          name="lf_block"
          (change)="changelfblock()"
        />
        <span class="slider round"></span>
      </label>
    </div>
  </div> -->

  <div class="d-flex justify-content-between" *ngIf="storageService.validateSoloAdmin()">
    <h5 class="m-0">{{ "settings-feeders.make-battery-panel-monitor" | translate }}</h5>
    <div class="d-flex justify-content-around align-items-center">
      <label class="switch m-0 ml-2">
        <input
          name="status"
          type="checkbox"
          class="custom-control-input"
          id="batteryPanel"
          [(ngModel)]="configuration.flag_monitoring"
          (change)="changeFlagMonitor(configuration.flag_monitoring)"
        />
        <span class="slider round"></span>
      </label>
    </div>
  </div>
</div>
